import { asMaybeasy, Maybe } from '@execonline-inc/structured-maybe';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { distanceOfTimeInWords } from '../../../../Time';
import { L, T } from '../../../../Translations';

interface Props {
  lastRegistrationDate: Maybe<Date>;
}

const LastRegistrationDate: React.FC<Props> = (props) => {
  return (
    <div
      className={clsx(
        'rounded border-1 border-solid border-gray-200',
        'mb-2 w-full bg-gray-10 px-4 py-3 text-gray-700 md:w-96',
      )}
    >
      <p className="text-xs">
        <T kind="Last registration date" />
      </p>
      <p className="mt-2 text-2xl font-medium">
        <_RegistrationDateAsDistanceWords {...props} />
      </p>
    </div>
  );
};

const _RegistrationDateAsDistanceWords = observer(({ lastRegistrationDate }: Props) => (
  <>
    {asMaybeasy(lastRegistrationDate)
      .map((date) => (
        <>
          <T {...distanceOfTimeInWords(new Date(), date)} />
          <span className="ml-1  text-sm">
            {'('}
            <L localizeable={date} format="long-month-day-year" />
            {')'}
          </span>
        </>
      ))
      .getOrElse(() => (
        <>--</>
      ))}
  </>
));

export default observer(LastRegistrationDate);
